import HundredBricksAPIError from '../../../HundredBricksAPIError';
class BricksReservationError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('BricksReservationError', ...args);
    }
}
export default BricksReservationError;
